import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import DropdownMenu from '../../../common/DropdownMenu';
import MoreVertIcon from 'material-ui-icons/MoreVert';
import Button from 'material-ui/Button';
import { isEnabledExportExecutiveList } from '../../../../utils/planUtils';

const styles = () => ({
  root: {
    color: '#71737B',
    padding: 0,
    minWidth: 'unset',
  },
  btnOpened: {
    color: 'rgb(26, 101, 255)',
  },
  dropdown: {
    minWidth: '180px',
    margin: '12px 0 12px 12px',
  },
  iconWrapper: {
    cursor: 'pointer',
  },
});

class Actions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      isMenuOpen: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    if (!this.state.isMenuOpen) {
      this.setState({ isHovered: false });
    }
  };

  handleMenuToggle = (open) => {
    this.setState({ isMenuOpen: open });
    if (!open) {
      this.setState({ isHovered: false });
    }
  };

  render() {
    const { classes, item, user, enableExecutiveListAdvancedSearch, toggleExecDetailItemDialog, toggleCsvDownloadDialog } = this.props;
    const { isHovered, isMenuOpen } = this.state;

    return (
      <div
        className={classes.iconWrapper}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {isHovered || isMenuOpen ? (
          <DropdownMenu
            menuItems={
              [
                {
                  name: "詳細",
                  func: () => {
                    toggleExecDetailItemDialog(item);
                  }
                }
              ].concat((enableExecutiveListAdvancedSearch || isEnabledExportExecutiveList(user)) ? [
                {
                  name: "CSVダウンロード",
                  func: () => {
                    toggleCsvDownloadDialog(item);
                  }
                }
              ] : [])
            }
            classes={{
              btn: classes.root,
              btnOpened: classes.btnOpened,
              dropdown: classes.dropdown,
            }}
            popperPlacement="bottom-end"
            onClick={() => this.handleMenuToggle(!isMenuOpen)}
          >
            <MoreVertIcon />
          </DropdownMenu>
        ) : (
          <Button
            className={classes.root}
            style={{ minWidth: 'unset', padding: 0 }}
          >
            <MoreVertIcon />
          </Button>
        )}
      </div>
    );
  }
}

Actions.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  toggleExecDetailItemDialog: PropTypes.func.isRequired,
  toggleCsvDownloadDialog: PropTypes.func.isRequired,
};

export default withStyles(styles)(Actions);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/cols/Actions.jsx